/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable import/prefer-default-export */
import { useReducer, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import toastr from 'toastr';
import * as load from '../../../../constants/types/shared/LoadingTypes';
import * as types from '../../../../constants/types/asset-team/AssetTeamTypes';
import { activeReducer } from '../../../../reducers/asset-team/active/activeReducer';
import { GET_ROUTER_URL } from '../../../../services/api/shared/BasestationsUrl';

export const useActiveCustomer = () => {
  const [{ items, time, customers, total, isLoading }, dispatch] = useReducer(activeReducer, {
    items: [],
    time: '',
    customers: [],
    total: 0,
    isLoading: false,
  });

  useEffect(() => {
    async function getActive() {
      const params = {
        action: 'tizeti_asset_active_count_get_cron',
      };
      const config = {
        method: 'post',
        url: `${GET_ROUTER_URL}`,
        data: qs.stringify(params),
      };

      await axios(config)
        .then((response) => {
          // console.log('response', response.data);
          if (response.data !== '') {
            dispatch({
              type: types.GET_ACTIVE_CUSTOMER,
              payload: {
                items: response.data.active_per_basestation.items,
                time: response.data.readable_last_updated_at,
                total: response.data.total_active_customer,
              },
            });
          }
        })
        .catch((error) => {
          if (error) {
            toastr.info('Something went wrong!');
            dispatch({ type: load.LOADING_STOPS });
          }
        });
    }
    getActive();
  }, []);

  const getActiveDetails = async (data) => {
    dispatch({
      type: load.LOADING_STARTS,
    });
    try {
      const response = await axios.post(`${GET_ROUTER_URL}`, qs.stringify(data));
      if (response.data) {
        dispatch({
          type: types.GET_ACTIVE_CUSTOMER_DETAILS,
          payload: response.data.items,
        });
      } else
        dispatch({
          type: load.LOADING_STOPS,
        });
    } catch (e) {
      toastr.info('Something went wrong!');
      dispatch({
        type: load.LOADING_STOPS,
      });
    }
  };

  return {
    time,
    items,
    total,
    customers,
    isLoading,
    getActiveDetails,
  };
};
